import { widgetSearch } from "@/features/protection-widget/widget-navigation";
import { createFileRoute } from "@tanstack/react-router";
import { CartPage } from "@/features/protection-widget/cart/cart-page";

export const Route = createFileRoute("/widget/cart")({
  validateSearch: widgetSearch,
  component: CartRoute,
});

function CartRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <CartPage
      {...search}
      onConsumeIntent={() => void navigate({ search: {}, replace: true, resetScroll: false })}
    />
  );
}
